// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1750":"94a11a53","3089":"ee2f541f"}[chunkId] + ".chunk.css";
};